<template>
  <header class="header">
    <MonitoringTypeFilter />
    <MonitoringStatusFilter />

  </header>
</template>
<script>
import MonitoringTypeFilter from './MonitoringTypeFilter'
import MonitoringStatusFilter from './MonitoringStatusFilter'

export default {
    components: {
      MonitoringTypeFilter,
      MonitoringStatusFilter
    },

    methods: {
    },
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    margin-right: 25px;
  }
}
</style>
